module.exports = __webpack_public_path__ + "img/3화_3-2(2).29122946.png";